// Converts a base64 data URL into a Blob so it can be used with
// URL.createObjectURL (browsers refuse to load data URLs over 2 MiB in frames).
export const dataUrlToBlob = (dataUrl, fallbackType) => {
  const [prefix, payload] = dataUrl.includes('base64,')
    ? dataUrl.split('base64,')
    : ['', dataUrl];
  const match = /^data:([^;,]+)/.exec(prefix);
  const type = (match && match[1]) || fallbackType;

  const binaryString = window.atob(payload);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return new Blob([bytes], { type });
};
